import {
  Box,
  Button,
  Heading,
  Input,
  Text,
  VStack,
  useColorModeValue,
  FormControl,
  FormLabel,
  Container,
  Stack,
} from "@chakra-ui/react";
import React, { useState, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { Link } from "react-router-dom";

const Forgot = () => {
  const [email, setEmail] = useState("");
  const { forgotPassword } = useContext(AppContext);

  // Theme hooks
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.900", "white");
  const subTextColor = useColorModeValue("gray.600", "gray.400");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const themeColor = "#319795";
  const hoverColor = "teal.600";
  const inputBg = useColorModeValue("white", "gray.700");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email !== "") {
      forgotPassword(email);
    }
  };

  return (
    <Box
      w="100%"
      minH="100vh"
      bg={bg}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Container maxW="lg">
        <Stack
          spacing={8}
          mx="auto"
          maxW="lg"
          py={12}
          px={6}
        >
          <Stack align="center">
            <Heading fontSize="4xl" color={textColor} textAlign="center">
              Forgot Password
            </Heading>
            <Text fontSize="lg" color={subTextColor} textAlign="center">
              You'll receive an email to reset your password ✌️
            </Text>
          </Stack>
          <Box
            rounded="lg"
            bg={cardBg}
            boxShadow="lg"
            p={8}
            borderWidth="1px"
            borderColor={borderColor}
          >
            <Stack spacing={4} as="form" onSubmit={handleSubmit}>
              <FormControl id="email" isRequired>
                <FormLabel color={textColor}>Email address</FormLabel>
                <Input
                  type="email"
                  placeholder="your-email@example.com"
                  value={email}
                  onChange={handleChange}
                  bg={inputBg}
                  borderColor={borderColor}
                  color={textColor}
                  _focus={{
                    borderColor: themeColor,
                    boxShadow: `0 0 0 1px ${themeColor}`,
                  }}
                />
              </FormControl>
              <Stack spacing={10}>
                <Button
                  type="submit"
                  bg={themeColor}
                  color="white"
                  _hover={{
                    bg: hoverColor,
                  }}
                  size="lg"
                  fontSize="md"
                >
                  Request Reset
                </Button>
              </Stack>
              <Stack pt={6}>
                <Text align="center" color={subTextColor}>
                  Remember your password?{" "}
                  <Link to="/login" style={{ color: themeColor, fontWeight: "bold" }}>
                    Login
                  </Link>
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Forgot;
